module.exports = __webpack_public_path__ + "static/media/angle-double-up.e9442c0e.svg";